import 'core-js/modules/es.object.assign.js';
import axios from 'axios';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.regexp.constructor.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.string.trim.js';
import 'core-js/modules/es.array.some.js';
import 'core-js/modules/es.array.for-each.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.splice.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.object.values.js';
import 'core-js/modules/es.string.includes.js';
import React, { useRef, useState } from 'react';
import { Col, Row, View } from '@amzn/stencil-react-components/layout';
import { TextArea, Select } from '@amzn/stencil-react-components/form';
import { Button, ButtonVariant, ButtonSize } from '@amzn/stencil-react-components/button';
import { IconBin, IconSize } from '@amzn/stencil-react-components/icons';
import { PopoverController } from '@amzn/stencil-react-components/popover';
import { Text, Label } from '@amzn/stencil-react-components/text';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-java';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/ext-language_tools';
import { Chip, ChipSize } from '@amzn/stencil-react-components/chip';

var MY_HR_GATEWAY_BACKEND_ID = 'myhr-gateway';
var TELLUS_CLIENT_ID = 'TellUs';
var MY_HR_GATEWAY_ROUTER_PATH = '/router';
// CSRF constants
var CSRF_META_TAG_NAME = 'tellus-csrf-token';
var CSRF_META_QUERY_SELECTOR_STRING = "meta[name='" + CSRF_META_TAG_NAME + "']";
var CSRF_TOKEN_CONTENT_ATTRIBUTE = 'content';
// MyHRAuthentication headers
var CLIENT_ID_HEADER_NAME = 'x-client-id';
var CLIENT_STAGE_HEADER_NAME = 'x-client-stage';
var BACKEND_ID_HEADER_NAME = 'x-backend-id';
var CSRF_HEADER_NAME = 'x-csrf-token';
// MyHRAuthentication endpoints
var MY_HR_AUTH_PROFILE_ENDPOINT = "/profile";
// HTTP status codes
var HTTP_UNAUTHORIZED_STATUS_CODE = 401;
var HTTP_FORBIDDEN_STATUS_CODE = 403;
// error messages
var MISSING_CSRF_TOKEN_ERROR_MESSAGE = 'Invalid or missing CSRF token';
var CSRF_TOKEN_NOT_PRESENT_IN_DOM_ERROR_MESSAGE = 'CSRF Token not present in the DOM.';

/**
 * Returns current stage of the UI app.
 * Populates the stage name from the deploy time replacement `Stage`.
 */
var getStage = function getStage() {
  return 'alpha';
};
var isNullOrUndefined = function isNullOrUndefined(input) {
  return input == null || input == undefined;
};
/**
 * Finds matching strings for a passed value from an array of strings.
 */
var getMatchingStrings = function getMatchingStrings(value, attributes) {
  if (!value) {
    return attributes;
  }
  var escapedValue = escapeRegexCharacters(value.trim());
  var regex = new RegExp('^' + escapedValue, 'i');
  return attributes.filter(function (attribute) {
    return regex.test(attribute);
  });
};
var escapeRegexCharacters = function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

var Stage;
(function (Stage) {
  Stage["test"] = "test";
  Stage["alpha"] = "alpha";
  Stage["beta"] = "beta";
  Stage["gamma"] = "gamma";
  Stage["prod"] = "prod";
})(Stage || (Stage = {}));
var HttpMethod;
(function (HttpMethod) {
  HttpMethod["GET"] = "get";
  HttpMethod["POST"] = "post";
  HttpMethod["PUT"] = "put";
  HttpMethod["UPDATE"] = "update";
  HttpMethod["DELETE"] = "delete";
})(HttpMethod || (HttpMethod = {}));
var JsonLogicOperator;
(function (JsonLogicOperator) {
  JsonLogicOperator["and"] = "and";
  JsonLogicOperator["or"] = "or";
  JsonLogicOperator["equal"] = "==";
  JsonLogicOperator["notEqual"] = "!=";
  JsonLogicOperator["in"] = "in";
  JsonLogicOperator["greaterThan"] = ">";
  JsonLogicOperator["greaterThanOrEqual"] = ">=";
  JsonLogicOperator["lessThan"] = "<";
  JsonLogicOperator["lessThanOrEqual"] = "<=";
  JsonLogicOperator["some"] = "some";
})(JsonLogicOperator || (JsonLogicOperator = {}));

var _MyHRAuthenticationUr;
// MyHRAuthentication service urls
var MyHRAuthenticationUrls = (_MyHRAuthenticationUr = {}, _MyHRAuthenticationUr[Stage.test] = 'https://authn.beta.tellus.myhr.a2z.com/', _MyHRAuthenticationUr[Stage.alpha] = 'https://authn.beta.tellus.myhr.a2z.com/', _MyHRAuthenticationUr[Stage.beta] = 'https://authn.beta.tellus.myhr.a2z.com/', _MyHRAuthenticationUr[Stage.gamma] = 'https://authn.gamma.tellus.myhr.a2z.com/', _MyHRAuthenticationUr[Stage.prod] = 'https://authn.tellus.myhr.a2z.com/', _MyHRAuthenticationUr);

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined$1;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

/**
 * Returns user info of the logged in user. Calls MyHRAuthentication Profile API.
 */
var getUserProfile = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(myhrAuthServiceClient) {
    var _error$response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return myhrAuthServiceClient.get({}, MY_HR_AUTH_PROFILE_ENDPOINT);
        case 3:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          if (!(axios.isAxiosError(_context.t0) && ((_error$response = _context.t0.response) == null ? void 0 : _error$response.status) === HTTP_UNAUTHORIZED_STATUS_CODE)) {
            _context.next = 10;
            break;
          }
          throw new Error('User is not authenticated');
        case 10:
          throw new Error("Error occurred while calling MyHRAuthentication Profile API: " + _context.t0);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return function getUserProfile(_x) {
    return _ref.apply(this, arguments);
  };
}();

var isCSRFRefreshing = false;
var requestQueue = [];
/**
 * Intercepts axios requests for MyHRAuthentication Service and if required adds CSRF token header.
 * @param requestConfig Axios request config
 */
var csrfRequestInterceptor = function csrfRequestInterceptor(requestConfig) {
  if (isCSRFTokenRequired(requestConfig)) {
    var _Object$assign;
    requestConfig.headers = Object.assign({}, requestConfig.headers, (_Object$assign = {}, _Object$assign[CSRF_HEADER_NAME] = getCSRFToken(requestConfig), _Object$assign));
  }
  return requestConfig;
};
/**
 * Intercepts axios responses from MyHRAuthentication Service and if CSRF token header is present saves it in DOM.
 * @param response Axios response
 */
var csrfResponseInterceptor = function csrfResponseInterceptor(response) {
  var csrfToken = response.headers[CSRF_HEADER_NAME];
  if (csrfToken) {
    setCSRFToken(csrfToken);
  }
  return response;
};
/**
 * Intercepts axios response errors from MyHRAuthentication Service.
 * If request failed due to CSRF error, Fetches new CSRF token and retries the request once.
 * @param error axios error response
 */
var getCsrfResponseErrorInterceptor = function getCsrfResponseErrorInterceptor(myhrAuthServiceClient) {
  return function (error) {
    var originalRequest = error.config;
    if (isCSRFError(error) && !originalRequest._isRetry) {
      originalRequest._isRetry = true;
      var retryRequestPromise = new Promise(function (resolve, reject) {
        requestQueue.push(function (isSuccess) {
          if (isSuccess) {
            // Use csrfRequestInterceptor to attach new csrf tokens before retrying requests.
            return resolve(axios(csrfRequestInterceptor(originalRequest)));
          }
          return reject(error);
        });
      });
      if (!isCSRFRefreshing) {
        refreshCSRFToken(myhrAuthServiceClient);
      }
      return retryRequestPromise;
    }
    return Promise.reject(error);
  };
};
/**
 * Returns CSRF token for MyHRAuthentication Service present in the DOM.
 * Throws error if token is not found.
 */
var getCSRFToken = function getCSRFToken(requestConfig) {
  var csrfMetaElement = document.querySelector(CSRF_META_QUERY_SELECTOR_STRING);
  var csrfToken = csrfMetaElement == null ? void 0 : csrfMetaElement.getAttribute(CSRF_TOKEN_CONTENT_ATTRIBUTE);
  if (!csrfToken) {
    throw {
      message: CSRF_TOKEN_NOT_PRESENT_IN_DOM_ERROR_MESSAGE,
      config: requestConfig
    };
  }
  return csrfToken;
};
/**
 * Sets the passed CSRF token for MyHRAuthentication Service in the DOM.
 * @param csrfToken CSRF token received from MyhRAuthentication Service.
 */
var setCSRFToken = function setCSRFToken(csrfToken) {
  var csrfMetaElement;
  try {
    var _csrfMetaElement;
    csrfMetaElement = document.querySelector(CSRF_META_QUERY_SELECTOR_STRING);
    (_csrfMetaElement = csrfMetaElement) == null ? void 0 : _csrfMetaElement.setAttribute(CSRF_TOKEN_CONTENT_ATTRIBUTE, csrfToken);
  } catch (error) {
    console.error('Failed to set CSRF token in DOM: ', error);
  }
};
/**
 * Calls MyHRAuthentication /profile API to refresh CSRF token. Once CSRF token is refreshed, retries all requests in queue.
 */
var refreshCSRFToken = function refreshCSRFToken(myhrAuthServiceClient) {
  isCSRFRefreshing = true;
  getUserProfile(myhrAuthServiceClient).then(function () {
    isCSRFRefreshing = false;
    requestQueue.forEach(function (callback) {
      return callback(true);
    });
    requestQueue = [];
  })["catch"](function () {
    isCSRFRefreshing = false;
    requestQueue.forEach(function (callback) {
      return callback(false);
    });
    requestQueue = [];
  });
};
/**
 * Returns whether CSRF token needs to be added to the passed request.
 * @param requestConfig Axios request config
 */
var isCSRFTokenRequired = function isCSRFTokenRequired(requestConfig) {
  var _requestConfig$method;
  var httpMethod = (_requestConfig$method = requestConfig.method) == null ? void 0 : _requestConfig$method.toLowerCase();
  return httpMethod !== HttpMethod.GET;
};
/**
 * Returns whether the passes error is due to missing or invalid CSRF token,
 * @param error axios error response
 */
var isCSRFError = function isCSRFError(error) {
  var _error$response, _error$response2;
  return (error == null ? void 0 : (_error$response = error.response) == null ? void 0 : _error$response.status) === HTTP_FORBIDDEN_STATUS_CODE && (error == null ? void 0 : (_error$response2 = error.response) == null ? void 0 : _error$response2.data) === MISSING_CSRF_TOKEN_ERROR_MESSAGE || (error == null ? void 0 : error.message) === CSRF_TOKEN_NOT_PRESENT_IN_DOM_ERROR_MESSAGE;
};

/**
 * Client to call MyHR Authentication Service.
 * Sets the required request configurations(headers, path, queryParams etc.)
 * and uses request/response interceptors to handle csrf related logic to correctly call AuthN service.
 */
var MyHRAuthBackendClient = /*#__PURE__*/function () {
  function MyHRAuthBackendClient(_ref) {
    var _ref$backendId = _ref.backendId,
      backendId = _ref$backendId === void 0 ? MY_HR_GATEWAY_BACKEND_ID : _ref$backendId,
      _ref$stage = _ref.stage,
      stage = _ref$stage === void 0 ? getStage() : _ref$stage;
    this.backendId = backendId;
    this.axiosInstance = axios.create({
      baseURL: MyHRAuthenticationUrls[stage],
      withCredentials: true
    });
    this.axiosInstance.interceptors.request.use(csrfRequestInterceptor);
    this.axiosInstance.interceptors.response.use(csrfResponseInterceptor, getCsrfResponseErrorInterceptor(this));
  }
  /**
   * Send a GET call to MyHRAuthenticationService.
   * @param queryParams key-value pairs that are attached to the end of a url.
   * @param path The specific resource in the host that the web client wants to access.
   * default: For {@link MY_HR_GATEWAY_BACKEND_ID} {@link MY_HR_GATEWAY_ROUTER_PATH}, otherwise path is not added.
   * @param headers key-value pairs of headers that need to be passed to the backend service.
   * @return A Promise<AxiosResponse> for the constructed axios GET request.
   */
  var _proto = MyHRAuthBackendClient.prototype;
  _proto.get = function get(queryParams, path, headers) {
    if (path === void 0) {
      path = this.getDefaultPath();
    }
    return this.axiosInstance.get(path, {
      params: queryParams,
      headers: Object.assign({}, this.getDefaultHeaders(), headers)
    });
  }
  /**
   * Send a POST call to MyHRAuthenticationService.
   * @param body Body to be passed to backend service.
   * @param queryParams key-value pairs that are attached to the end of a url.
   * @param path The specific resource in the host that the web client wants to access.
   * default: For {@link MY_HR_GATEWAY_BACKEND_ID} {@link MY_HR_GATEWAY_ROUTER_PATH}, otherwise path is not added.
   * @param headers key-value pairs of headers that need to be passed to the backend service.
   * @return A Promise<AxiosResponse> for the constructed axios POST request.
   */;
  _proto.post = function post(body, queryParams, path, headers) {
    if (path === void 0) {
      path = this.getDefaultPath();
    }
    return this.axiosInstance.post(path, body, {
      params: queryParams,
      headers: Object.assign({}, this.getDefaultHeaders(), headers)
    });
  }
  /**
   * Returns {@link MY_HR_GATEWAY_ROUTER_PATH} when backendId is {@link MY_HR_GATEWAY_BACKEND_ID}, otherwise returns empty string.
   */;
  _proto.getDefaultPath = function getDefaultPath() {
    if (this.backendId === MY_HR_GATEWAY_BACKEND_ID) {
      return MY_HR_GATEWAY_ROUTER_PATH;
    }
    return '';
  }
  /**
   * Returns headers that need to be sent along with the request to MyHRAuthenticationService.
   */;
  _proto.getDefaultHeaders = function getDefaultHeaders() {
    var _ref2;
    return _ref2 = {}, _ref2[CLIENT_ID_HEADER_NAME] = TELLUS_CLIENT_ID, _ref2[CLIENT_STAGE_HEADER_NAME] = this.getClientStageForAuthN(), _ref2[BACKEND_ID_HEADER_NAME] = this.backendId, _ref2;
  }
  /**
   * Returns the client stage to be passed to AuthN service.
   */;
  _proto.getClientStageForAuthN = function getClientStageForAuthN() {
    var currentStage = getStage();
    if (currentStage === Stage.gamma || currentStage === Stage.prod) {
      return currentStage;
    }
    return Stage.beta;
  };
  return MyHRAuthBackendClient;
}();

var MultiArgumentJsonLogicOperators = [JsonLogicOperator.and, JsonLogicOperator.or];

/**
 * Renders a Text Area for user input, and a suggestion dropdown matching the user entered value.
 * The suggestion selected by the user is added as a variable in the json logic expression.
 */
var TextAreaWithSuggestions = function TextAreaWithSuggestions(_ref) {
  var argument = _ref.argument,
    onTextChange = _ref.onTextChange,
    suggestions = _ref.suggestions,
    onAttributeSelect = _ref.onAttributeSelect;
  var textAreaRef = useRef(null);
  var _useState = useState(false),
    isSuggestionPopoverOpen = _useState[0],
    setSuggestionPopoverOpen = _useState[1];
  var getTextAreaValueBasedOnArgument = function getTextAreaValueBasedOnArgument() {
    var _argument$var;
    return isNullOrUndefined(argument) ? "" : typeof argument === "object" ? (_argument$var = argument["var"]) != null ? _argument$var : JSON.stringify(argument) : argument;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextArea, {
    value: getTextAreaValueBasedOnArgument(),
    onChange: onTextChange,
    height: "45px",
    minHeight: "45px",
    width: "300px",
    resize: "both",
    ref: textAreaRef,
    onFocus: function onFocus() {
      return setSuggestionPopoverOpen(true);
    }
  }), /*#__PURE__*/React.createElement(PopoverController, {
    target: textAreaRef,
    isOpen: isSuggestionPopoverOpen,
    close: function close() {
      setSuggestionPopoverOpen(false);
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    gridGap: "1px",
    padding: {
      top: "4px",
      bottom: "4px",
      right: "2px",
      left: "2px"
    }
  }, getMatchingStrings(typeof argument == "string" ? argument : undefined, suggestions).map(function (attribute) {
    return /*#__PURE__*/React.createElement(Button, {
      key: "" + attribute,
      variant: ButtonVariant.Tertiary,
      size: ButtonSize.Small,
      onClick: function onClick(_) {
        onAttributeSelect(attribute);
        setSuggestionPopoverOpen(false);
      }
    }, /*#__PURE__*/React.createElement(Text, null, attribute));
  })))));
};
/**
 * Renders an Add Rule button for adding child rules in json logic expressions.
 */
var AddRuleButton = function AddRuleButton(_ref2) {
  var onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    variant: ButtonVariant.Secondary,
    size: ButtonSize.Small,
    onClick: onClick,
    style: {
      width: "fit-content"
    }
  }, "+ Add rule");
};
/**
 * Renders a Delete Rule button to delete child rules in a json logic expression.
 */
var DeleteRuleButton = function DeleteRuleButton(_ref3) {
  var onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    variant: ButtonVariant.Tertiary,
    isDestructive: true,
    icon: /*#__PURE__*/React.createElement(IconBin, {
      size: IconSize.Small
    }),
    onClick: onClick
  });
};

/**
 * This component is responsible for:
 * 1. Rendering a Json Logic expressions as UI components.
 * 2. Letting users define Json Logic expressions through the input boxes and suggestions rendered by this component.
 *
 * This component supports operators present in {@link JsonLogicOperator}.
 * This is not an exhaustive list of operators that json logic itself supports, ref: https://jsonlogic.com/operations.html.
 * As use-cases arise, we will add support for more operators supported by json logic.
 *
 * @param rule The json logic rule expression that needs to be rendered.
 * @param setRule Function trigerred when changes to the json logic rule happen via user input.
 * @param attributes Attributes to be shown as suggestions. These attributes act as the variables ("var"s) in the json logic rules constructed by this component.
 */
var JsonLogicRenderer = function JsonLogicRenderer(_ref) {
  var rule = _ref.rule,
    _setRule3 = _ref.setRule,
    attributes = _ref.attributes;
  // when rule is empty or not present
  if (!rule || !Object.keys(rule) || !Object.keys(rule).length) {
    return /*#__PURE__*/React.createElement(AddRuleButton, {
      onClick: function onClick() {
        var _setRule;
        // start with a basic equality condition when creating new rules
        _setRule3((_setRule = {}, _setRule[JsonLogicOperator.equal] = [], _setRule));
      }
    });
  }
  var currentOperator = Object.keys(rule)[0];
  // render a tree for multi argument operators
  if (MultiArgumentJsonLogicOperators.includes(currentOperator)) {
    var childRules = rule[currentOperator];
    return /*#__PURE__*/React.createElement(Row, {
      alignItems: "top",
      gridGap: "16px"
    }, /*#__PURE__*/React.createElement(Select, {
      options: MultiArgumentJsonLogicOperators,
      value: currentOperator,
      onChange: function onChange(value) {
        var _setRule2;
        // if any other operator is selected, move current rule tree to the new operator
        _setRule3((_setRule2 = {}, _setRule2[value] = childRules, _setRule2[currentOperator] = undefined, _setRule2));
      },
      width: "100px"
    }), /*#__PURE__*/React.createElement(Col, {
      gridGap: "8px"
    }, childRules && childRules.map(function (childRule, index) {
      // render a JsonLogicRenderer recursively for each child rule
      return /*#__PURE__*/React.createElement(JsonLogicRenderer, {
        attributes: attributes,
        rule: childRule,
        setRule: function setRule(rule) {
          var _setRule5;
          var childRulesPre = [].concat(childRules);
          var childRulesPost = [].concat(childRules);
          // handling deletion of child rule
          if (!rule) {
            var _setRule4;
            // the child JsonLogicRenderer component will set `undefined` to delete the rule
            // at parent level, we need to remove that rule from its index in the childRules array
            childRulesPre.splice(index, 1), _setRule3((_setRule4 = {}, _setRule4[currentOperator] = [].concat(childRulesPre), _setRule4));
            return;
          }
          // when child component calls this setRule function with a rule object,
          // update it in its index in the childRules array
          _setRule3((_setRule5 = {}, _setRule5[currentOperator] = [].concat(childRulesPre.splice(0, index), [rule], childRulesPost.splice(index + 1, childRules.length - (index + 1))), _setRule5));
        }
      });
    }), /*#__PURE__*/React.createElement(AddRuleButton, {
      onClick: function onClick() {
        var _ref2, _setRule6;
        _setRule3((_setRule6 = {}, _setRule6[currentOperator] = [].concat(childRules, [(_ref2 = {}, _ref2[JsonLogicOperator.equal] = [], _ref2)]), _setRule6));
      }
    })), !(childRules != null && childRules.length) && /*#__PURE__*/React.createElement(DeleteRuleButton, {
      onClick: function onClick() {
        _setRule3(undefined);
      }
    }));
  }
  // rest of the operators will only have two arguments
  var _rule$currentOperator = rule[currentOperator],
    firstArgument = _rule$currentOperator[0],
    secondArgument = _rule$currentOperator[1];
  return /*#__PURE__*/React.createElement(Row, {
    alignItems: "center",
    gridGap: "8px"
  }, /*#__PURE__*/React.createElement(TextAreaWithSuggestions, {
    argument: firstArgument,
    onTextChange: function onTextChange(e) {
      var _e$target, _setRule7;
      var value = e == null ? void 0 : (_e$target = e.target) == null ? void 0 : _e$target.value;
      try {
        var _e$target2;
        value = JSON.parse(e == null ? void 0 : (_e$target2 = e.target) == null ? void 0 : _e$target2.value);
      } catch (_) {}
      _setRule3((_setRule7 = {}, _setRule7[currentOperator] = [value, secondArgument], _setRule7));
    },
    suggestions: attributes.map(function (attribute) {
      return attribute.attributeName;
    }),
    onAttributeSelect: function onAttributeSelect(attribute) {
      var _ref3, _setRule8;
      _setRule3((_setRule8 = {}, _setRule8[currentOperator] = [(_ref3 = {}, _ref3["var"] = attribute, _ref3), secondArgument], _setRule8));
    }
  }), /*#__PURE__*/React.createElement(Select, {
    options: Object.values(JsonLogicOperator),
    value: currentOperator,
    onChange: function onChange(value) {
      var _setRule10;
      if (MultiArgumentJsonLogicOperators.includes(value)) {
        var _setRule9;
        _setRule3((_setRule9 = {}, _setRule9[currentOperator] = undefined, _setRule9[value] = [], _setRule9));
        return;
      }
      _setRule3((_setRule10 = {}, _setRule10[currentOperator] = undefined, _setRule10[value] = rule[currentOperator], _setRule10));
    },
    width: "100px"
  }), /*#__PURE__*/React.createElement(TextAreaWithSuggestions, {
    argument: secondArgument,
    onTextChange: function onTextChange(e) {
      var _e$target3, _setRule11;
      var value = e == null ? void 0 : (_e$target3 = e.target) == null ? void 0 : _e$target3.value;
      try {
        var _e$target4;
        value = JSON.parse(e == null ? void 0 : (_e$target4 = e.target) == null ? void 0 : _e$target4.value);
      } catch (_) {}
      _setRule3((_setRule11 = {}, _setRule11[currentOperator] = [firstArgument, value], _setRule11));
    },
    suggestions: attributes.map(function (attribute) {
      return attribute.attributeName;
    }),
    onAttributeSelect: function onAttributeSelect(attribute) {
      var _ref4, _setRule12;
      _setRule3((_setRule12 = {}, _setRule12[currentOperator] = [firstArgument, (_ref4 = {}, _ref4["var"] = attribute, _ref4)], _setRule12));
    }
  }), /*#__PURE__*/React.createElement(DeleteRuleButton, {
    onClick: function onClick() {
      _setRule3(undefined);
    }
  }));
};

var USER_DISPLAYED_STRINGS = {
  edit_as_json: 'Edit as Json'
};

/**
 * This component is responsible to let users author and view json logic expressions.
 *
 * It provides two ways of authoring json logic:
 * 1. In the form of dropdowns, text areas and suggestions for intuitive authoring of json logic expressions. Uses {@link JsonLogicRenderer} to do so.
 * 2. As a free form json input box, to let users define more complex json logic expressions which are not supported by the {@link JsonLogicRenderer} component.
 *
 * This component provides a toggle to switch between the two ways of authoring json logic expressions.
 *
 * @param jsonLogicExpression The json logic expression to be rendered.
 * @param setJsonLogicExpression Function called when user authors/makes changes to the json logic expression.
 * @param attributes Attributes to be shown as suggestions. These attributes will act as the variables ("var"s) in the json logic expressions constructed by this component.
 * @param header Header text for the component.
 * @param placeholder Placeholder to be shown in the json input box.
 */
var JsonLogicAuthoringComponent = function JsonLogicAuthoringComponent(_ref) {
  var jsonLogicExpression = _ref.jsonLogicExpression,
    setJsonLogicExpression = _ref.setJsonLogicExpression,
    attributes = _ref.attributes,
    header = _ref.header,
    placeholder = _ref.placeholder;
  var _useState = useState(false),
    editAsJson = _useState[0],
    setEditAsJson = _useState[1];
  var ruleObject;
  try {
    ruleObject = JSON.parse(jsonLogicExpression);
  } catch (_) {
    ruleObject = {};
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Label, {
    fontSize: "20px",
    fontWeight: "bold",
    htmlFor: "json-expression-editor"
  }, header), /*#__PURE__*/React.createElement(Chip, {
    isSelected: editAsJson,
    onClick: function onClick() {
      setEditAsJson(!editAsJson);
    },
    size: ChipSize.Small
  }, USER_DISPLAYED_STRINGS.edit_as_json)), editAsJson ? /*#__PURE__*/React.createElement(View, {
    border: "1px",
    id: "json-expression-editor"
  }, /*#__PURE__*/React.createElement(AceEditor, {
    value: jsonLogicExpression,
    onChange: function onChange(value) {
      setJsonLogicExpression(value);
    },
    mode: "java",
    width: "100%",
    height: "300px",
    theme: "github",
    fontSize: 18,
    name: "event-rule",
    editorProps: {
      $blockScrolling: true
    },
    placeholder: placeholder
  })) : /*#__PURE__*/React.createElement(JsonLogicRenderer, {
    attributes: attributes,
    rule: ruleObject,
    setRule: function setRule(rule) {
      if (!rule) {
        setJsonLogicExpression("");
        return;
      }
      setJsonLogicExpression(JSON.stringify(rule, null, 4));
    }
  }));
};

export { BACKEND_ID_HEADER_NAME, CLIENT_ID_HEADER_NAME, CLIENT_STAGE_HEADER_NAME, CSRF_HEADER_NAME, CSRF_META_QUERY_SELECTOR_STRING, CSRF_META_TAG_NAME, CSRF_TOKEN_CONTENT_ATTRIBUTE, CSRF_TOKEN_NOT_PRESENT_IN_DOM_ERROR_MESSAGE, HTTP_FORBIDDEN_STATUS_CODE, HTTP_UNAUTHORIZED_STATUS_CODE, HttpMethod, JsonLogicAuthoringComponent, JsonLogicOperator, JsonLogicRenderer, MISSING_CSRF_TOKEN_ERROR_MESSAGE, MY_HR_AUTH_PROFILE_ENDPOINT, MY_HR_GATEWAY_BACKEND_ID, MY_HR_GATEWAY_ROUTER_PATH, MyHRAuthBackendClient, MyHRAuthenticationUrls, Stage, TELLUS_CLIENT_ID, csrfRequestInterceptor, csrfResponseInterceptor, getCsrfResponseErrorInterceptor, getUserProfile };
//# sourceMappingURL=tell-us-app-website-ui-commons.esm.js.map
